import { Component, OnInit } from '@angular/core';
import { Feature, Geometry } from 'geojson';
import * as mapboxgl from 'mapbox-gl';
import { MapService } from './map.service';

@Component({
  selector: 'app-map-canvas',
  template: ''
})
export class MapCanvasComponent implements OnInit {

  private static SOURCE_ID = 'mitra-pulse-source';
  private static LAYER_ID = 'mitra-pulse-layer';
  private static IMAGE_ID = 'mitra-pulse-image';

  features: Feature<Geometry>[] = [];

  constructor(
    private mapService: MapService,
  ) { }

  ngOnInit(): void {
    this.mapService.map$.subscribe(map => {
      const size = 100;

      map.addImage(MapCanvasComponent.IMAGE_ID, new PulseLayerInterface(size), { pixelRatio: 2 });

      map.addSource(MapCanvasComponent.SOURCE_ID, {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: this.features
        }
      });
      map.addLayer({
        id: MapCanvasComponent.LAYER_ID,
        type: 'symbol',
        source: MapCanvasComponent.SOURCE_ID,
        layout: {
          'icon-image': MapCanvasComponent.IMAGE_ID
        },
        minzoom: 9,
        maxzoom: 22
      });
    });

    this.mapService.highlight$.subscribe(element => {
      this.addPulse(element.id, element.lng, element.lat);
    });

    this.mapService.removeHighlight$.subscribe(element => {
      this.removePulse(element.id);
    });
  }


  private addPulse(id: string, lng: number, lat: number) {
    this.features.push({
      id,
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [lng, lat],
      },
      properties: {}
    });
    this.update();
  }

  private removePulse(id: string) {
    const i = this.features.findIndex(f => f.id === id);
    this.features.splice(i, 1);
    this.update();
  }

  private update() {
    this.mapService.map$.subscribe(map => {
      const collection = map.getSource(MapCanvasComponent.SOURCE_ID) as mapboxgl.GeoJSONSource;
      collection.setData({
        type: 'FeatureCollection',
        features: this.features
      });
    });
  }

}

class PulseLayerInterface implements mapboxgl.CustomLayerInterface, ImageData {

  private static PI_2 = Math.PI * 2;
  private static DURATION = 1000;

  id: string;
  type: 'custom';
  renderingMode: '2d';

  width: number;
  height: number;
  data: Uint8ClampedArray;

  map: mapboxgl.Map;
  context: CanvasRenderingContext2D;

  radius: number;
  halfSize: number;

  constructor(private size: number) {
    this.data = new Uint8ClampedArray(size * size * 4);
    this.width = size;
    this.height = size;

    this.halfSize = size / 2;
    this.radius = (this.size / 2) * 0.3;
  }

  onAdd(map: mapboxgl.Map, gl: WebGLRenderingContext): void {
    this.map = map;

    const canvas = document.createElement('canvas');
    canvas.width = this.width;
    canvas.height = this.height;
    this.context = canvas.getContext('2d');
  }

  onRemove?(map: mapboxgl.Map, gl: WebGLRenderingContext): void {

  }
  prerender?(gl: WebGLRenderingContext, matrix: number[]): void {

  }
  render(gl: WebGLRenderingContext, matrix: number[]): boolean {
    const t = (performance.now() % PulseLayerInterface.DURATION) / PulseLayerInterface.DURATION;
    const outerRadius = (this.size / 2) * 0.7 * t + this.radius;

    // draw outer circle
    this.context.clearRect(0, 0, this.width, this.height);
    this.context.beginPath();
    this.context.arc(
      this.halfSize,
      this.halfSize,
      outerRadius,
      0,
      PulseLayerInterface.PI_2
    );
    this.context.fillStyle = 'rgba(255, 200, 200,' + (1 - t) + ')';
    this.context.fill();

    // update this image's data with data from the canvas
    this.data = this.context.getImageData(
      0,
      0,
      this.width,
      this.height
    ).data;

    // continuously repaint the map, resulting in the smooth animation of the dot
    this.map.triggerRepaint();

    // return `true` to let the map know that the image was updated
    return true;
  }

}
